
export const validationComp = (varname,label,border,labeltitle,type) => {
    if(!varname){
        label(labeltitle);
        border(true)
        return false
    }
    else if(type=="emailtype" && varname && !/\S+@\S+\.\S+/.test(varname)){
        label("Incorrect Email")
        border(true)
        return false
    }
    else{
        label("");
        border(false)
        return true
    }
}
export const validationDrp = (varname,label,border,labeltitle) =>{
    if(!varname){
        label(labeltitle);
        border("err")
        return false
    }
    else{
        label("");
        border("")
        return true
    }
}
